// @flow

import React from "react";
import {
  Grid,
  Card,
  Table,
  Page,
  Form,
} from "tabler-react";
import Moment from 'moment';
import Slider from "react-slick";

import "tabler-react/dist/Tabler.css";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import SiteWrapperSuperAdmin from "../SiteWrapper.superadmin.react";
import SiteWrapperAdmin from "../SiteWrapper.admin.react";
import authActions from "../../redux/auth/action";
import clientService from "../../services/client";
import ReadmorePopup from '../Readmore';
import InfoPopup from '../InfoPopup';
import socketIOClient from "socket.io-client";
import { changeLanguage } from '../../../src/language/index';
import botService from "../../services/bot";
import "../slick/slick.css";
import "../slick/slick-theme.css";
import {
  isAgentRole,
  getPageSize,
  normalizeChatUsers,
  getDisplayMobile,
  formatLanguage,
  toChronologicalMessages,
} from './chatHelpers';

var ENDPOINT = process.env.REACT_APP_baseUrl;
var socket;
var audio;

class ChatPage extends React.Component {

  constructor(props) {
    super(props);
    this.chatDiv = React.createRef();
    const isAgent = isAgentRole(props.user);
    this.state = {
      messageText: '',
      currentPage: 1,
      nextPage: false,
      totalRecords: 0,
      chatUsers: [],
      buttons: [],
      messages: [],
      selectChatUser: null,
      selectedFile: null,
      fileName: '',
      fileSize: 0,
      formDisabled: isAgent,
      files: [],
      openPopup: false,
      openInfoPopup: false,
      page: 1,
      engageNumber: 0,
      search: '',
    };
    audio = new Audio('/notification_tune.mp3');
    // Ignore stale message fetches when the agent switches chats quickly.
    this.messagesLoadToken = 0;
    this.loadingOlderMessages = false;
    // Opening a chat sets scrollTop to 0; ignore that so we don't load older pages by accident.
    this.suppressHistoryLoad = false;
    // Keep the thread pinned to the latest message unless the agent scrolls up.
    this.shouldStickToBottom = true;
    this.handleChange = this.handleChange.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.closeInfoPopup = this.closeInfoPopup.bind(this);
  }

  isAgent() {
    return isAgentRole(this.props.user);
  }

  pageSize() {
    return getPageSize(this.props.user);
  }

  closePopup() {
    this.setState({
      openPopup: {
        open: false,
        data: false,
      },
    });
  }

  closeInfoPopup() {
    this.setState({
      openInfoPopup: {
        open: false,
        data: false,
      },
    });
  }

  openInfoPopup(e, data) {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    if (!data) {
      return;
    }

    let arr = data.entity ? [...data.entity] : [];

    if (this.isAgent()) {
      const uniqueKeys = new Set();
      arr = arr.filter((obj) => {
        if (!uniqueKeys.has(obj['entity'])) {
          uniqueKeys.add(obj['entity']);
          return true;
        }
        return false;
      });

      arr = arr.map((el) => {
        let obj = { ...el };
        if (el.entity === "step_1") {
          obj.entity = "Rating";
        }
        if (el.entity === "step_2") {
          obj.entity = "Department";
        }
        if (el.entity === "step_3") {
          obj.entity = "Suggestion";
        }
        return obj;
      });

      arr = arr.filter((el) => el.entity !== "lab_id");
    } else {
      if (data.prescription) {
        arr.push({ entity: "prescription", value: data.prescription });
      }
      if (data.test_mode) {
        arr.push({ entity: "test_mode", value: data.test_mode });
      }
      arr = arr.filter((item) => item.entity !== 'city');
    }

    this.setState({
      openInfoPopup: {
        open: true,
        data: arr,
      },
    });
  }

  openPopup(e, data) {
    this.setState({
      openPopup: {
        open: true,
        data: data,
      },
    });
  }

  handleChange = (e) => {
    const val = e.target.value;
    this.setState({ messageText: val });
    if (e.keyCode === 13 && e.shiftKey === false) {
      this.emitMessage(e);
    }
  }

  componentDidMount() {
    document.title = "Voiceoc | Chat";

    if (this.isAgent()) {
      if (typeof Notification !== 'undefined') {
        Notification.requestPermission();
      }
      botService.getButtons()
        .then((res) => {
          if (res.statusCode === 200) {
            this.setState({ buttons: res.data.result });
          }
        })
        .catch(() => {});
      this.engageNumberApi();
    }

    this.getChatUsers(1, this.state.search);

    const jwtToken = localStorage.getItem('jwtToken');
    if (jwtToken) {
      socket = socketIOClient(ENDPOINT, { query: `authorization=${jwtToken}` });
      if (socket && !socket.connected) {
        socket.once('connect', () => {});
      }

      socket.on("chatting", (data) => {
        if (data.event === 'receive-message') {
          if (audio) {
            audio.play();
          }
          if (this.isAgent()) {
            window.focus();
            if (typeof Notification !== 'undefined') {
              new Notification('New Notification recieved');
            }
          }
          this.getChatUsers(this.state.currentPage, this.state.search, true);
          if (this.state.selectChatUser) {
            this.getMessages(1);
          }
        } else if (data.event === 'initiate-chat') {
          if (audio) {
            audio.play();
          }
          this.getChatUsers(this.state.currentPage, this.state.search, true);
          if (this.isAgent()) {
            this.engageNumberApi();
          }
        } else if (data.event === 'end-chat') {
          // Cron / system end-chat: lock the composer immediately, then refresh the list.
          if (audio) {
            audio.play();
          }
          this.closeAgentChat(data);
          this.getChatUsers(this.state.currentPage, this.state.search, true);
          if (this.isAgent()) {
            this.engageNumberApi();
          }
          if (this.state.selectChatUser) {
            this.getMessages(1);
          }
        }
      });
    }
  }

  componentWillUnmount() {
    if (socket) {
      socket.off("chatting");
      socket.disconnect();
      socket = null;
    }
  }

  async engageNumberApi() {
    try {
      let engageData = await clientService.getCount();
      this.setState({
        engageNumber: engageData.data.engageNumbers,
      });
    } catch (error) {
      console.log(error);
    }
  }

  handleScroll(event) {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    this.shouldStickToBottom = (scrollHeight - scrollTop - clientHeight) < 80;

    // Only fetch older messages when the agent actually scrolls to the top.
    if (this.suppressHistoryLoad || this.loadingOlderMessages) {
      return;
    }
    if (scrollTop > 0 || scrollHeight <= clientHeight) {
      return;
    }
    this.getMessages(this.state.page + 1);
  }

  // After the chat list refreshes, keep the open thread in sync and disable
  // the composer if cron (or the agent) has already ended it.
  syncSelectedUser(chatUsers) {
    const { selectChatUser } = this.state;
    if (!selectChatUser) {
      return;
    }
    const matched = chatUsers.find((user) =>
      user.id === selectChatUser.id
      || (user.chatId && selectChatUser.chatId && String(user.chatId) === String(selectChatUser.chatId))
      || (user.mobileNumber && selectChatUser.mobileNumber && user.mobileNumber === selectChatUser.mobileNumber)
    );
    if (matched) {
      const updates = { selectChatUser: matched };
      if (this.isAgent()) {
        updates.formDisabled = matched.status === 'deactive';
      }
      this.setState(updates);
    }
  }

  // Disable typing/send as soon as this open chat is ended, without waiting for the list API.
  closeAgentChat(payload) {
    if (!this.isAgent()) {
      return;
    }
    const selected = this.state.selectChatUser;
    if (!selected || !payload) {
      return;
    }
    const endedMobile = payload.mobileNumber;
    const endedChatId = payload.chatId;
    const sameMobile = endedMobile && selected.mobileNumber === endedMobile;
    const sameChat = endedChatId && String(selected.chatId) === String(endedChatId);
    if (sameMobile || sameChat) {
      this.setState({
        formDisabled: true,
        selectChatUser: Object.assign({}, selected, { status: 'deactive' }),
      });
    }
  }

  isCurrentChat(chatId) {
    return this.state.selectChatUser
      && this.state.selectChatUser.mobileNumber === chatId;
  }

  async getMessages(page = 1) {
    const { selectChatUser } = this.state;
    if (!selectChatUser || !selectChatUser.mobileNumber) {
      return;
    }

    const chatId = selectChatUser.mobileNumber;
    // Bump the token so a slow response from a previous chat cannot overwrite this one.
    const token = page === 1 ? this.messagesLoadToken + 1 : this.messagesLoadToken;
    if (page === 1) {
      this.messagesLoadToken = token;
      this.suppressHistoryLoad = true;
      this.shouldStickToBottom = true;
    } else {
      if (this.loadingOlderMessages) {
        return;
      }
      this.loadingOlderMessages = true;
    }

    try {
      const res = await clientService.getAllMessages(chatId, page);
      if (token !== this.messagesLoadToken || !this.isCurrentChat(chatId)) {
        return;
      }
      if (res.statusCode !== 200) {
        return;
      }

      const pageMessages = toChronologicalMessages(res.data.result || []);
      if (page === 1) {
        this.setState({
          messages: pageMessages,
          page: 1,
        }, () => {
          // setState callback + rAF: scroll after the messages are actually in the DOM.
          this.scrollToBottom();
          window.requestAnimationFrame(() => {
            this.scrollToBottom();
            this.suppressHistoryLoad = false;
          });
        });
        return;
      }

      if (pageMessages.length) {
        const container = this.chatDiv.current;
        const previousHeight = container ? container.scrollHeight : 0;
        this.setState({
          messages: toChronologicalMessages(pageMessages.concat(this.state.messages)),
          page,
        }, () => {
          // Keep the same messages on screen after older history is prepended.
          if (this.chatDiv.current) {
            this.chatDiv.current.scrollTop =
              this.chatDiv.current.scrollHeight - previousHeight;
          }
        });
      }
    } catch (err) {
      console.error(err);
      if (page === 1 && token === this.messagesLoadToken) {
        this.suppressHistoryLoad = false;
      }
    } finally {
      if (page > 1) {
        this.loadingOlderMessages = false;
      }
    }
  }

  scrollToBottom = () => {
    const el = this.chatDiv.current;
    if (!el) {
      return;
    }
    el.scrollTop = el.scrollHeight;
  };

  handleImageLoad = () => {
    // Images change scrollHeight after paint; re-pin to latest if the agent was already at the bottom.
    if (this.shouldStickToBottom) {
      this.scrollToBottom();
    }
  };

  getChatUsers(page, search, highlited = false, sortKey = false, sortType = false) {
    const isAgent = this.isAgent();
    const limit = this.pageSize();
    const request = isAgent
      ? clientService.getChatUsers(page, search, limit, false, sortKey, sortType)
      : clientService.getAllChatUsers(page, search, limit, false, sortKey, sortType);

    request
      .then(async (res) => {
        if (res.statusCode === 200) {
          let dataArray = res.data.result || [];

          if (!isAgent) {
            dataArray = Object.values(dataArray.reduce((acc, cur) => {
              if (!acc[cur.mobileNumber] || acc[cur.mobileNumber].updatedAt < cur.updatedAt) {
                acc[cur.mobileNumber] = cur;
              }
              return acc;
            }, {}));
          }

          if (highlited && dataArray.length > 0) {
            dataArray[0]['highlited'] = true;
          }

          const chatUsers = normalizeChatUsers(dataArray, isAgent);
          await this.setState({
            chatUsers,
            currentPage: page,
            nextPage: res.data.next,
            totalRecords: res.data.total,
          });
          this.syncSelectedUser(chatUsers);
        }
      })
      .catch((error) => {
        if (error && error.response && error.response.data && error.response.data.statusCode === 201) {
          this.props.logOut();
          this.props.history.push("/login");
        }
        console.log(error);
      });
  }

  formatDate(date) {
    return Moment(date).format('DD/MM/YY h:mm a');
  }

  getPagination() {
    const page = this.state.currentPage;
    const pageSize = this.pageSize();
    const total = this.state.totalRecords || 0;
    const startRecord = page === 1 ? 1 : ((pageSize * (page - 1)) + 1);
    const endRecord = parseInt(startRecord, 10) + parseInt(this.state.chatUsers.length, 10) - 1;
    if (!this.state.chatUsers.length) {
      return '0-0 of ' + total;
    }
    return startRecord + '-' + endRecord + ' of ' + total;
  }

  async selectUserToChat(e, user) {
    if (this.isAgent() && !user) {
      alert('No customer details were found');
      return;
    }

    const formDisabled = this.isAgent()
      ? (user.status === 'deactive')
      : this.state.formDisabled;

    this.suppressHistoryLoad = true;
    this.shouldStickToBottom = true;
    this.setState({
      selectChatUser: user,
      messages: [],
      page: 1,
      formDisabled,
    }, () => {
      this.getMessages(1);
    });
  }

  async emitMessage(event) {
    event.preventDefault();
    if (!this.isAgent()) {
      return false;
    }
    if (!this.state.selectChatUser) {
      toast.success('Please first select the user.');
      return false;
    }
    if (this.state.formDisabled || this.state.selectChatUser.status === 'deactive') {
      // Extra guard: composer can look enabled for a moment after cron ends the chat.
      toast.error('This chat has ended.');
      return false;
    }

    const selected = this.state.selectChatUser;
    const customerDetail = selected.detail;
    let emitData = {
      event: 'send-message',
      data: {
        chatId: selected.chatId,
        mobileNumber: selected.mobileNumber,
        body: this.state.messageText,
        media: [],
        customerDetail,
      },
    };

    if (this.state.selectedFile) {
      clientService.uploadFile(this.state.selectedFile)
        .then((response) => {
          const filesData = response.data;
          emitData.data.media.push(filesData);
          socket.emit("chat", emitData);
          this.clearSelectedFile();
          this.setState({ messageText: '' });
          const form = document.getElementById("chatForm");
          if (form) {
            form.reset();
          }
          this.getChatUsers(this.state.currentPage, this.state.search, true);
          this.getMessages(1);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      if (this.state.messageText === '' || this.state.messageText == null) {
        toast.error('Please Type something.');
        return false;
      }
      socket.emit("chat", emitData);
      this.setState({ messageText: '' });
      const form = document.getElementById("chatForm");
      if (form) {
        form.reset();
      }
      this.getChatUsers(this.state.currentPage, this.state.search, true);
      this.getMessages(1);
    }
  }

  onChangeFile = (event) => {
    event.preventDefault();
    if (!this.state.selectChatUser) {
      toast.success('Please first select the user.');
      event.target.value = '';
      return false;
    }
    const file = event.target.files && event.target.files[0];
    if (!file) {
      return false;
    }
    const data = new FormData();
    data.append('media', file);
    this.setState({
      selectedFile: data,
      fileName: file.name,
      fileSize: file.size,
    });
  }

  clearSelectedFile = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.setState({
      selectedFile: null,
      fileName: '',
      fileSize: 0,
    });
    const input = document.getElementById('chatFileInput');
    if (input) {
      input.value = '';
    }
  }

  chatEnd(e, selectChatUser) {
    if (!selectChatUser) {
      toast.success('Please first select the user.');
      return false;
    }
    let chatEndData = {
      chatId: selectChatUser.chatId,
      mobileNumber: selectChatUser.mobileNumber,
    };

    clientService.endChat(chatEndData)
      .then(() => {
        toast.success('Chat end successfully');
        this.setState({
          formDisabled: true,
        });
        this.getChatUsers(this.state.currentPage, this.state.search);
        if (this.isAgent()) {
          this.engageNumberApi();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  orderByChatList(e) {
    if (e.target.value === 'latest') {
      this.getChatUsers(1, this.state.search, false);
    } else {
      var valueKey = e.target.value.split('_');
      this.getChatUsers(1, this.state.search, false, valueKey[1], valueKey[0]);
    }
  }

  pagination(e, page) {
    if (page < 1) {
      return;
    }
    this.getChatUsers(page, this.state.search);
  }

  getButtonData = (data) => {
    this.setState({ messageText: data });
  }

  async handleSearch(event) {
    await this.setState({
      search: event.target.value,
      currentPage: 1,
    });
    this.getChatUsers(1, this.state.search);
  }

  renderMessageMedia(message, isCustomer) {
    const hasMedia = message && Array.isArray(message.media) && message.media.length > 0;
    const isImage = hasMedia
      && message.media[0]
      && message.media[0].mimeType !== null
      && message.media[0].mimeType.split('/')[0] === 'image';

    if (isCustomer) {
      if (isImage) {
        return (
          <div>
            <img src={message.media[0].url} alt="" onLoad={this.handleImageLoad} />
            {message.message ? <p className="chat-message-body">{message.message}</p> : null}
          </div>
        );
      }
      if (hasMedia) {
        return (
          <a target="_blank" rel="noopener noreferrer" href={message.media[0].url}>
            {message.media[0].originalName}
          </a>
        );
      }
      return message.message ? (
        <span className="chat-message-body">{message.message}</span>
      ) : null;
    }

    if (hasMedia && message.message) {
      return (
        <>
          <a target="_blank" rel="noopener noreferrer" href={message.media[0].url}>
            {message.media[0].originalName}
          </a>
          <br />
          <span className="chat-message-body">{message.message}</span>
        </>
      );
    }
    if (isImage) {
      return (
        <div>
          <img src={message.media[0].url} alt="" onLoad={this.handleImageLoad} />
          {message.message ? <p className="chat-message-body">{message.message}</p> : null}
        </div>
      );
    }
    if (hasMedia) {
      return (
        <a target="_blank" rel="noopener noreferrer" href={message.media[0].url}>
          {message.media[0].originalName}
        </a>
      );
    }
    return message.message ? (
      <span className="chat-message-body">{message.message}</span>
    ) : null;
  }

  render() {
    const {
      selectChatUser,
      nextPage,
      chatUsers,
      messages,
      buttons,
      currentPage,
    } = this.state;
    const isAgent = this.isAgent();
    const Wrapper = isAgent ? SiteWrapperAdmin : SiteWrapperSuperAdmin;
    const settings = {
      dots: true,
      autoplay: false,
      infinite: true,
      speed: 500,
      slidesToShow: buttons.length < 4 ? (buttons.length || 1) : 4,
      slidesToScroll: 1,
    };

    return (
      <Wrapper>
        <Page.Content>
          <audio id="audio"><source src="/notification_tune.mp3" type="audio/mp3"></source></audio>

          <div>
            <Grid.Row>
              {isAgent ? (
                <div className="page-header">
                  <div className="col col-sm-12 row ascv">
                    <div className="d-flex col-sm-4">
                      <select className="custom-select" onChange={(e) => this.orderByChatList(e)}>
                        <option value="latest">
                          {changeLanguage(this.props.siteLanguage, 'time_latest_first')}
                        </option>
                        <option value="asc_name">
                          {changeLanguage(this.props.siteLanguage, 'name_a_z')}
                        </option>
                        <option value="desc_name">
                          {changeLanguage(this.props.siteLanguage, 'name_z_a')}
                        </option>
                      </select>
                    </div>
                    <div className="col col-sm-4">
                      <div className="form-control">
                        Active Chats : {` ${this.state.engageNumber}`}
                      </div>
                    </div>
                    <div className="col col-sm-4 engage-bo">
                      <input
                        name="search"
                        className="form-control"
                        type="text"
                        placeholder="Search"
                        value={this.state.search}
                        onChange={(e) => this.handleSearch(e)}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col col-sm-6">
                  <div className="page-header">
                    <div className="d-flex col-sm-6">
                      <select className="custom-select auto1" onChange={(e) => this.orderByChatList(e)}>
                        <option value="latest">
                          {changeLanguage(this.props.siteLanguage, 'time_latest_first')}
                        </option>
                        <option value="asc_name">
                          {changeLanguage(this.props.siteLanguage, 'name_a_z')}
                        </option>
                        <option value="desc_name">
                          {changeLanguage(this.props.siteLanguage, 'name_z_a')}
                        </option>
                      </select>
                    </div>
                    <div className="d-flex col-sm-6">
                      <input
                        name="search"
                        className="form-control"
                        type="text"
                        placeholder="Search"
                        value={this.state.search}
                        onChange={(e) => this.handleSearch(e)}
                      />
                    </div>
                  </div>
                </div>
              )}
            </Grid.Row>

            <Grid.Row>
              <div className="col col-sm-6">
                <Card className="card01a">
                  <Table
                    cards={true}
                    striped={true}
                    responsive={true}
                    className="table-vcenter tablebackground"
                  >
                    <Table.Header>
                      <Table.Row>
                        <Table.ColHeader className="capitilize fontSize"> </Table.ColHeader>
                        {!isAgent ? (
                          <Table.ColHeader className="capitilize fontSize"> </Table.ColHeader>
                        ) : null}
                        <Table.ColHeader className="capitilize fontSize aligntd">
                          {changeLanguage(this.props.siteLanguage, 'name')}
                        </Table.ColHeader>
                        <Table.ColHeader className="capitilize fontSize aligntd">
                          {changeLanguage(this.props.siteLanguage, 'date')}
                        </Table.ColHeader>
                        <Table.ColHeader className="capitilize fontSize aligntd">
                          {changeLanguage(this.props.siteLanguage, 'mobile_number')}
                        </Table.ColHeader>
                        <Table.ColHeader className="capitilize fontSize">Context </Table.ColHeader>
                        {!isAgent ? (
                          <Table.ColHeader className="capitilize fontSize">Source</Table.ColHeader>
                        ) : (
                          <Table.ColHeader className="capitilize fontSize">Language</Table.ColHeader>
                        )}
                        <Table.ColHeader className="capitilize fontSize"></Table.ColHeader>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {chatUsers.length ? (
                        chatUsers.map((user, childIndex) => (
                          <tr
                            key={user.id || childIndex}
                            className={
                              "" +
                              (selectChatUser && user.id === selectChatUser.id ? "highlitedtr" : "") +
                              (isAgent && user.status === 'active' ? " boldtd" : "") +
                              " "
                            }
                            style={{ cursor: 'pointer' }}
                            onClick={(e) => this.selectUserToChat(e, user)}
                          >
                            {!isAgent ? (
                              <td className="w-1 sticky-col">
                                {user.color === 'green' && (
                                  <span className="avatar1" data-tooltip="flow completed"></span>
                                )}
                                {user.color === 'red' && (
                                  <span className="avatar2" data-tooltip="Service not selected yet"></span>
                                )}
                                {user.color === 'yellow' && (
                                  <span className="avatar3" data-tooltip="service selected but flow incomplete"></span>
                                )}
                                {user.color === 'blue' && (
                                  <span className="avatar4" data-tooltip="flow Completed and feedback provided"></span>
                                )}
                              </td>
                            ) : null}
                            <td className="w-1 sticky-col">
                              {user.highlited ? <span className="avatar1"></span> : null}
                            </td>
                            <td className="cursorPointer sticky-col aligntd">
                              <span>{user.name}</span>
                            </td>
                            <td className="aligntd">
                              {this.formatDate(user.updatedAt)}
                            </td>
                            <td className="aligntd">
                              {getDisplayMobile(user)}
                            </td>
                            <td className="">
                              {user.context}
                            </td>
                            <td className="">
                              {isAgent ? formatLanguage(user.language) : user.source}
                            </td>
                            <td className="w-1">
                              <a
                                className="icon"
                                onClick={(e) => this.openInfoPopup(e, user.detail)}
                              >
                                {user.entity && user.entity.length > 0 ? (
                                  <i className="fe fe-info"></i>
                                ) : null}
                              </a>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <Table.Row>
                          <Table.Col colSpan={7}>Sorry!  no data found.</Table.Col>
                        </Table.Row>
                      )}
                    </Table.Body>
                  </Table>
                  <div className="form-group" style={{ float: 'right' }}>
                    <label className="form-label"></label>
                    <div className="selectgroup align-to-right paginations">
                      <span>{this.getPagination()}</span>
                      <i
                        className={
                          "fe " +
                          (currentPage <= 1 ? "not-active " : "cursorPointer ") +
                          " fe-chevron-left"
                        }
                        onClick={(e) => this.pagination(e, currentPage - 1)}
                      >
                      </i>
                      <i
                        className={
                          "fe " +
                          (!nextPage ? "not-active " : "cursorPointer ") +
                          " fe-chevron-right"
                        }
                        onClick={(e) => this.pagination(e, currentPage + 1)}
                      >
                      </i>
                    </div>
                  </div>
                </Card>
              </div>

              <div className="col col-sm-6 topChatBoc">
                <div className="card card2">
                  <div className="card-header1">
                    <h3 className="card-title card-t1">
                      {selectChatUser
                        ? selectChatUser.name
                        : changeLanguage(this.props.siteLanguage, 'chat')}
                    </h3>
                    <div className="card-options">
                      {isAgent ? (
                        <button
                          className={
                            " bg-black marginChatBox " +
                            (this.state.formDisabled ? " disablebutton" : " ") +
                            ""
                          }
                          onClick={(e) => {
                            if (window.confirm('Are you sure to end chat?')) {
                              this.chatEnd(e, selectChatUser);
                            }
                          }}
                          disabled={this.state.formDisabled}
                        >
                          {changeLanguage(this.props.siteLanguage, 'end_chat')} {this.state.formDisabled}
                        </button>
                      ) : null}
                    </div>
                  </div>
                  <div
                    className="card-body card1"
                    ref={this.chatDiv}
                    onScroll={(e) => this.handleScroll(e)}
                  >
                    <ul className="list-unstyled list-separated">
                      {messages && messages.length
                        ? messages.map((message, childIndex) => (
                          message ? (
                            <div key={(message._id || childIndex) + '_' + childIndex}>
                              {(message.messageFrom === 'user' || message.messageFrom === 'customer') ? (
                                <li className="list-separated-item">
                                  <div className="row row align-items-center botchat">
                                    <div className="col col-auto">
                                      <span className="avatar avatar-md d-block usertextcolor userbackground1">
                                        C
                                      </span>
                                    </div>
                                    <div className="col">
                                      <div>
                                        <span className="text-inherit chat-message-text">
                                          {this.renderMessageMedia(message, true)}
                                          <p>{this.formatDate(message.createdAt)}</p>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              ) : (
                                <li className={`list-separated-item ${message.messageFrom === 'agent' ? 'text-color' : ''}`}>
                                  <div className="row row align-items-center">
                                    <div className="col">
                                      <div className="col01">
                                        <span className="text-inherit chat-message-text">
                                          {this.renderMessageMedia(message, false)}
                                          <p>{this.formatDate(message.createdAt)}</p>
                                        </span>
                                      </div>
                                    </div>
                                    <div className="col col-auto">
                                      <span className="avatar avatar-md d-block usertextcolor userbackground">
                                        {isAgent ? 'C' : 'M'}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                              )}
                            </div>
                          ) : null
                        ))
                        : null}
                    </ul>
                  </div>

                  <div className="car18">
                    {isAgent ? (
                      <>
                        <div className="button-slider">
                          <Slider {...settings}>
                            {buttons && buttons.map((value) => (
                              <div key={value._id}>
                                <h3
                                  title={value.text}
                                  onClick={() => this.getButtonData(value.text)}
                                >
                                  {value.name}
                                </h3>
                              </div>
                            ))}
                          </Slider>
                        </div>
                        <form id="chatForm" className="chat-composer">
                          <Form.Group label="">
                            <div className="form-group">
                              <textarea
                                className="form-control"
                                name="messageText"
                                placeholder="Type"
                                value={this.state.messageText}
                                onChange={(e) => this.handleChange(e)}
                                onKeyDown={(e) => this.handleChange(e)}
                                disabled={this.state.formDisabled}
                              >
                              </textarea>
                            </div>
                          </Form.Group>
                          <div className="chat-composer-actions">
                            {/* Native file input is hidden; paperclip + filename is the visible control. */}
                            <label
                              className={
                                "chat-file-picker" +
                                (this.state.formDisabled ? " is-disabled" : "")
                              }
                              htmlFor="chatFileInput"
                            >
                              <span className="chat-file-picker-icon">
                                <i className="fe fe-paperclip"></i>
                              </span>
                              <span
                                className={
                                  "chat-file-picker-name" +
                                  (this.state.fileName ? " has-file" : "")
                                }
                                title={this.state.fileName || 'No file chosen'}
                              >
                                {this.state.fileName || 'No file chosen'}
                              </span>
                            </label>
                            <input
                              type="file"
                              disabled={this.state.formDisabled}
                              name="file"
                              id="chatFileInput"
                              className="chat-file-input-hidden"
                              onChange={(e) => this.onChangeFile(e)}
                            />
                            <button
                              type="button"
                              className="btn btn-primary chat-send-btn"
                              disabled={this.state.formDisabled}
                              onClick={(e) => this.emitMessage(e)}
                            >
                              {changeLanguage(this.props.siteLanguage, 'send_message')}
                            </button>
                          </div>
                        </form>
                      </>
                    ) : (
                      <form id="chatForm"></form>
                    )}
                    <div className="pull-right dis-non">
                      <span className="stamp stamp-md bg-1 marginBottom10" onClick={(e) => this.openPopup(e, '123')}>
                        <i className="fe fe-dollar-sign"></i>
                      </span>
                      <span className="stamp stamp-md bg-2 marginBottom10" onClick={(e) => this.openPopup(e, '123')}>
                        <i className="fe fe-shopping-cart"></i>
                      </span>
                      <span className="stamp stamp-md bg-3 marginBottom10">
                        <i className="fe fe-users" onClick={(e) => this.openPopup(e, '123')}></i>
                      </span>
                      <span className="stamp stamp-md bg-4 marginBottom10" onClick={(e) => this.openPopup(e, '123')}>
                        <i className="fe fe-message-square"></i>
                      </span>
                      <span className="stamp stamp-md btn bg-5 marginBottom10" onClick={(e) => this.openPopup(e, '123')}>
                        <i className="fe fe-shopping-cart"></i>
                      </span>
                      <span className="stamp stamp-md btn bg-6 marginBottom10" onClick={(e) => this.openPopup(e, '123')}>
                        <i className="fe fe-dollar-sign"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <ReadmorePopup
                openPopup={this.state.openPopup}
                onChange={this.closePopup}
              />
              <InfoPopup
                openInfoPopup={this.state.openInfoPopup}
                onChange={this.closeInfoPopup}
              />
            </Grid.Row>
          </div>
        </Page.Content>
        <ToastContainer autoClose={5000} position={'bottom-right'} />
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    activeBot: state.auth.activeBot,
    siteLanguage: state.auth.siteLanguage,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    logOut: () => {
      dispatch(authActions.authLogout());
    },
    setLang: (payload) => {
      dispatch(authActions.setLang(payload));
    },
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChatPage));
